import React from 'react'
import '../Footer/footer.css'
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Link } from 'react-router-dom';
import useScrollToTop from './useScrollToTop';

const Footer = () => {
    useScrollToTop();
  return (
    <footer className="footer">
            <div className="section__container footer__container">
                <div className="footer__col">
                    <h4>P.K. REAL ESTATE</h4>
                    <p style={{fontStyle:'italic',fontFamily:'serif'}} >
                        Our expert team is dedicated to delivering exceptional service, deep market insights, and personalized solutions just for you.
                    </p>
                    <div className="footer__socials">
                        <span>
                        <a href="https://www.facebook.com/login/" ><FacebookIcon style={{ color: '#4267B2' }}/></a>
                        </span>
                        <span>
                        <a href="https://www.instagram.com/shubharambhfarmhouse/profilecard/?igsh=ZWR5bmJ4M2dyMGs5"><InstagramIcon style={{ color: '#C13584' }}/></a>
                        </span>
                        <span>
                        <a href="https://www.linkedin.com/in/ishaan-k-054820299?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><LinkedInIcon style={{ color: '#0077B5' }}/></a>
                        </span>
                    </div>
                </div>
                <div className="footer__col">
                    <h4>Company Info</h4>
                    <Link style={{fontStyle:'italic',fontFamily:'serif'}} className='a' to='/uhome/home'>Home</Link>
        <Link style={{fontStyle:'italic',fontFamily:'serif'}} className='a' to='/uhome/property'>Properties</Link>
        <Link style={{fontStyle:'italic',fontFamily:'serif'}} className='a' to='/uhome/about'>About</Link>
        <Link style={{fontStyle:'italic',fontFamily:'serif'}} className='a' to='/uhome/contact'>Contact Us</Link>
                </div>
                <div className="footer__col">
                    <h4>Resources</h4>
                    <p style={{fontStyle:'italic',fontFamily:'serif'}}>Terms</p>
                    <p style={{fontStyle:'italic',fontFamily:'serif'}}>Conditions</p>
                    <p style={{fontStyle:'italic',fontFamily:'serif'}}>Policy</p>
                </div>
                <div className="footer__col">
                    <h4>Contact</h4>
                    <a  style={{fontStyle:'italic',fontFamily:'serif'}} href="mailto:pkrealestate4@gmail.com">
                    <EmailOutlinedIcon/>pkrealestate4@gmail.com
                    </a>
                    <a  style={{fontStyle:'italic',fontFamily:'serif'}} href="tel:+918369816370"><CallOutlinedIcon/>
                        +91 8369816370
                    </a>
                </div>
            </div>
            <div className="footer__bar">
                Copyright © 2025 P.K. Real Estate. All rights reserved.
            </div>
        </footer>
  )
}

export default Footer
